import { IContentInitialState } from "../../../types/master/contentInterface";
import { ContentActionTypes, ContentActions } from "../../actionTypes/master/contentActionTypes";


const initialState: IContentInitialState = {
  contentList: [],
  contentData: {
    id: 0,
    content_label: "",
    slug: "",
    created_by: 0,
  },
  contentListPageCount: 0,
};

export default function contentReducer(state = initialState, action: ContentActionTypes): IContentInitialState {
  switch (action.type) {

    case ContentActions.SET_CONTENT_LIST:
      return {
        ...state,
        contentList: action.payload,
      };

    case ContentActions.SET_CONTENT_LIST_PAGE_COUNT:
      return {
        ...state,
        contentListPageCount: action.payload
      };

    case ContentActions.SET_CONTENT_DATA_BY_ID:
      return {
        ...state,
        contentData: action.payload,
      };

    default:
      return state;
  }
}